import React from 'react';
import { FiZap } from 'react-icons/fi';
import ServiceTemplate from './ServiceTemplate';

export default function SoftwareEngineeringService() {
  return (
    <ServiceTemplate
      slug="software-engineering"
      color="#7c3aed"
      icon={<FiZap size={40} />}
      title="Software Engineering Consulting"
      tagline="Full-stack engineering teams embedded in your workflow — shipping production code from week one."
      heroDescription="Whether you need to build a new product from scratch, modernize legacy systems, or scale your engineering capacity — our teams integrate seamlessly with your stack, tools, and processes. We don't just write code, we ship outcomes."
      features={[
        { title: 'Full-Stack Product Development', description: 'End-to-end development from architecture through deployment. React, Next.js, Node, Python, Go — we match the right stack to your requirements.' },
        { title: 'API Design & Microservices', description: 'RESTful and GraphQL API design, microservice decomposition, event-driven architecture, and API gateway management.' },
        { title: 'Legacy Modernization', description: 'Migrate monoliths to modern architectures incrementally with zero downtime. We specialize in strangler fig patterns and progressive rewrites.' },
        { title: 'DevOps & Infrastructure', description: 'CI/CD pipelines, Infrastructure as Code, container orchestration, monitoring, and cost optimization across AWS, GCP, and Azure.' },
        { title: 'Performance Engineering', description: 'Load testing, profiling, caching strategies, database optimization, and CDN configuration to hit your latency and throughput targets.' },
        { title: 'Staff Augmentation', description: 'Embed senior engineers directly into your team — working in your repos, your standups, your tools. Scale up or down as needed.' },
      ]}
      useCases={[
        { title: 'SaaS Platform Rebuild', description: 'Rebuilt a legacy PHP SaaS platform into a modern React + Node microservices architecture.', result: '60% faster page loads, 3x developer velocity' },
        { title: 'Startup MVP to Production', description: 'Took a fintech startup from Figma designs to production in 8 weeks with a 3-person team.', result: 'Launched on schedule, 10K users in first month' },
        { title: 'Enterprise API Platform', description: 'Designed and built an API gateway serving 50M+ requests/day for a logistics company.', result: '99.99% uptime, sub-50ms P95 latency' },
      ]}
      techStack={[
        'React', 'Next.js', 'TypeScript', 'Node.js', 'Python', 'Go',
        'PostgreSQL', 'MongoDB', 'Redis', 'Elasticsearch',
        'AWS', 'GCP', 'Azure', 'Docker', 'Kubernetes',
        'Terraform', 'GitHub Actions', 'CircleCI', 'Datadog', 'Grafana',
      ]}
    />
  );
}
